import React from 'react';
import './informal.css';
import Navbar from '../home_page/navbar';
import Footer from '../home_page/footer';
import EventHost1 from '../../Data/Assets/images/event_host_1.png';
import EventHost2 from '../../Data/Assets/images/event_host_2.png';
import InformalVideos from './informal_videos';

function Informal() {
  return (
    <div className="being-informal-with">
      <Navbar></Navbar>
      <div className="informal-page">
        <div className="title-text-colored informal-title">Being Informal With...</div>
        <div className="page-content">
          <p>
            We have started a new chat show with eminent and experienced scientists. We will strive
            to conduct a show every month and bring to you the great scientists from our proud
            country. Currently the show will be hosted by Nitendra Singh. As the name of the chat
            show suggests, the talk will be informal and very casual. Through this show, we will
            bring to you their non scientific/technical side along with their experiences, life
            lessons and their advice.
          </p>
        </div>
        <div className="hosts">
          <div className="title">
            <p className="title-text-black">Event Host</p>
          </div>
          <div class="hosts-info">
            <div className="host host1">
              <div className="host-name-image">
                <img className="host__image" alt="hostImage" src={EventHost1}></img>
                <p className="host__name">Dr. Nitendra Singh</p>
                <p className="host__position">Founder and President of IYNS</p>
              </div>
              <div className="host-intro">
                <p className="host__description host1__description">
                  Dr. Nitendra Singh is the Founder and President of IYNS, Nuclear engineer by
                  profession, he's fond of traveling, photography & hiking. Also, he is passionate
                  about cooking. His research interests includes nuclear safety & design, reactor
                  thermal hydraulics, Nuclear severe accidents. In addition, he's an avid speaker on
                  Nuclear4Climate, advanced technologies and public awareness.
                </p>
              </div>
            </div>
            <div className="host host2">
              <div className="host-name-image">
                <img className="host__image" alt="hostImage" src={EventHost2}></img>
                <p className="host__name">Prof. J. B. Joshi</p>
                <p className="host__position">Emeritus Professor, HBNI</p>
              </div>
              <div className="host-intro">
                <p className="host__description host2__description">
                  From being born in a small town in Maharashtra to getting a Padma Bhushan in 2014,
                  come learn how Dr. Joshi's passion for teaching drove him to success. Prof. J. B.
                  Joshi is an Indian chemical engineer, nuclear scientist, consultant and professor,
                  widely known for his innovations in reactor designs and generally regarded as a
                  respected teacher. He is the DAE-Homi Bhabha Chair Professor, Homi Bhabha National
                  Institute, Mumbai, and is the recipient of Shantiswarup Bhatnagar Prize for
                  Engineering Sciences and many other awards and recognitions.
                </p>
              </div>
            </div>
          </div>
        </div>
        <InformalVideos />
      </div>
      <Footer></Footer>
    </div>
  );
}

export default Informal;
